<script setup lang="ts">
import LeTopBanner from "@dsk/components/LeTopBanner.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { config } from "@/config";

const { t } = useI18n();
const route = useRoute();

const { site } = config.app;

const returnUrl = computed<string>(() => {
  const newHost = window.location.hostname.replace("beta.", "www.");
  return `//${newHost}${route.fullPath}`;
});
</script>

<template>
  <LeTopBanner type="attention">
    <i18n-t tag="span" keypath="le-beta-banner.information">
      <template #domain>
        <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
        <a class="link" href="#">beta.{{ site }}.com</a>
      </template>
    </i18n-t>
    {{ " " }}
    <a class="link" :href="returnUrl">{{ t("le-beta-banner.return-link", { domain: `${site}.com` }) }}</a>
  </LeTopBanner>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";
</style>
